<template>
  <div class="item b-img">
    <div class="title">
      정부에서 추진하는<br />
      <b>무이자 대출이니까!</b>
    </div>
    <div class="content">
      계약 금리 11%, 실질 부담은 2.5% 내외<br />
      상환 완료시 대출금액의 4.5%를<br />
      인센티브로 다시 돌려드려요!<br />
      (자료증빙시)
    </div>
    <div class="content2">
      <div class="item-detail">
        <img src="@/assets/images/fundanow-style-main/SectionReason/item1.svg" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'One',
}
</script>

<style lang="scss" scoped>
.item {
  font-family: 나눔스퀘어, 'NanumSquare', sans-serif !important;
  background-color: white;
  width: 280px;
  height: 340px;
  border-radius: 6px;
  box-shadow: 8px 10px 20px 0 rgba(0, 0, 0, 0.12);
  padding-top: 23px;
  background-image: url('../../../../assets/images/fundanow-style-main/SectionReason/bg1.png');
  background-size: contain;
  overflow: hidden;

  .title {
    font-family: 나눔스퀘어, 'NanumSquare', sans-serif !important;
    font-weight: 500;
    font-size: 20px;
    line-height: 1.35;
    letter-spacing: -0.63px;
    text-align: center;
    color: #333333;
    b {
      font-weight: 800;
      color: #333333;
    }
  }

  .content {
    font-weight: 500;
    font-size: 15px;
    line-height: 1.4;
    letter-spacing: -0.47px;
    text-align: center;
    color: #727d8c;
    margin-top: 9px;
  }

  .content2 {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    margin-top: 32px;
    align-items: center;
    justify-content: center;
  }
}
</style>
